import { Component, OnInit } from '@angular/core';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  stagger,
} from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SearchService } from '../../search/search/search.service';
import { ServiceRfqTokenAuthService } from 'src/app/shared/services/service-rfq-token-auth.service';

@Component({
  selector: 'app-service-token-login',
  templateUrl: './serviceTokenLogin.component.html',
  styleUrls: ['./serviceTokenLogin.component.css'],
  animations: [
    trigger('pageFadeUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(100vh)' }),
        animate(
          '1200ms cubic-bezier(.22,1,.36,1)',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
    trigger('staggerFadeUp', [
      transition(':enter', [
        query(
          '.stagger-item',
          [
            style({ opacity: 0, transform: 'translateY(13px)' }),
            stagger(80, [
              animate(
                '350ms ease-out',
                style({ opacity: 1, transform: 'translateY(0)' })
              ),
            ]),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
})
export class ServiceTokenLoginComponent implements OnInit {
  securityToken = '';
  loading = false;
  private redirectUrl = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private searchService: SearchService,
    private serviceRfqTokenAuth: ServiceRfqTokenAuthService
  ) {}

  ngOnInit() {
    this.redirectUrl = this.route.snapshot.queryParamMap.get('redirect') || '';
  }

  async verifyToken() {
    const raw = (this.securityToken || '').trim();
    if (!raw) {
      this.snackBar.open('Please enter a valid Security Token', 'Close', {
        duration: 3000,
      });
      return;
    }

    this.loading = true;
    try {
      const data: any = await this.searchService.verifyServiceRfqToken(raw);
      if (data?.valid) {
        if (data?.serviceRfqAccessToken && data?.serviceRfqId) {
          this.serviceRfqTokenAuth.set(data.serviceRfqAccessToken, data.serviceRfqId, data?.supplierId);
        }
        this.snackBar.open('Token verified successfully', 'Close', {
          duration: 3000,
        });
        if (data?.serviceRfqId) {
          this.router.navigate(['/serviceRfqToken/rfqDetails', data.serviceRfqId]);
        }
      } else {
        const reason = data?.reason;
        const msg = reason === 'expired'
          ? 'Token has expired. Please contact the buyer for a new token.'
          : 'Invalid token. Please check and try again.';
        this.snackBar.open(msg, 'Close', {
          duration: 3500,
        });
      }
    } catch (err) {
      this.snackBar.open('Verification failed. Please try again.', 'Close', {
        duration: 3500,
      });
    } finally {
      this.loading = false;
    }
  }
}
